import React from 'react';
import build from '../build.svg';
import hopper from '../hopper_mid2.png'
import '../App.css';
import {
    Row,
    Col
} from 'bootstrap-4-react';

const styles = {
  strip: {
      backgroundColor: "rgb(235, 71, 38)",
      width: "100%",
      padding: "1em",
      marginTop: "2em"
  },
  date: {
    display: "inline",
    fontWeight: "bold",
    marginRight: ".5em",
    fontSize: "3em"
  },
  time: {
    display: "inline",
    fontSize: "3em"
  }
}

function FirstRow({eventDate}) {

  return (
      <div>
      <Row>
          <Col col="md">
            <h1 id="title">Станьте экспертом механизированного нанесения декора</h1>
              <h2 className={'subtitle'}>Регистрируйтесь на открытый вебинар по технологии механизированного нанесения <strong>декоративной штукатурки</strong> с <strong style={{color: '#e8231c'}}>прямым эфиром</strong> из нашей мастерской</h2>
          </Col>
          <Col col="md">
            <img id="build" src={hopper} alt="здание" />
          </Col>
      </Row>
      <Row>
          <Col col="md">
            <div id="strip" style={styles.strip}>

                <p style={styles.date}>{eventDate.date}</p>
                <p style={styles.time}>{eventDate.time} МСК</p>
            </div>
          </Col>
      </Row>
      </div>

  );
}

export default FirstRow;
